import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=5038f24b&scoped=true"
import script from "./BlockTitle.vue?vue&type=script&lang=js"
export * from "./BlockTitle.vue?vue&type=script&lang=js"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=5038f24b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5038f24b",
  null
  
)

export default component.exports